import { render, staticRenderFns } from "./SlotList.vue?vue&type=template&id=13a8216a&scoped=true&"
import script from "./SlotList.vue?vue&type=script&lang=js&"
export * from "./SlotList.vue?vue&type=script&lang=js&"
import style0 from "./SlotList.vue?vue&type=style&index=0&id=13a8216a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8216a",
  null
  
)

export default component.exports